import HomePage from "../pages/HomePage";
import MenuPage from "../pages/MenuPage";
import OrderConfirmationPage from "../pages/OrderConfirmationPage";
import OffersPage from "../pages/OffersPage";
import CheckoutPage from "../pages/CheckoutPage";
import { GiftcardPurchasePage } from "../pages/giftcard/purchase";

// const HomePage = lazy(() => import("../pages/HomePage"));
// const MenuPage = lazy(() => import("../pages/MenuPage"));
// const OffersPage = lazy(() => import("../pages/OffersPage"));
// const CheckoutPage = lazy(() => import("../pages/CheckoutPage"));
// const OrderConfirmationPage = lazy(() => import("../pages/OrderConfirmationPage"));

export const publicRoutes = [
  { path: "/", element: <HomePage /> },
  { path: "/home", element: <HomePage /> },
  { path: "/menu", element: <MenuPage /> },
  { path: "/giftcard/purchase", element: <GiftcardPurchasePage /> },
  { path: "/menu/:categoryId", element: <MenuPage /> },
  { path: "/menu/:categoryId/:productId", element: <MenuPage /> },
  { path: "/offer-and-rewards", element: <OffersPage /> },
  { path: "/checkout", element: <CheckoutPage /> },
  { path: "/orders/:orderId", element: <OrderConfirmationPage /> },
  { path: "/order-confirmation/:orderId", element: <OrderConfirmationPage /> },
];
